// Přidání tlačítek do DOM
if ($('.type-detail').length) {
    // 🟢 DETAIL PRODUKTU
    const codes = getShoptetDataLayer('product').codes || [];
    const ids = codes.map(c => c.code);
    const productId = $('#product-detail-form meta[itemprop="productID"]').attr('content');

    $('.p-info-wrapper .social-buttons-wrapper .link-icons').append(`
        <div class="customFavorite">
            <span class="add-to-favorites" data-id="${productId}" data-ids='${JSON.stringify(ids)}'>
                Přidat do oblíbených
            </span>
        </div>
    `);
} else if ($('.products .product').length) {
    // 🟡 VÝPIS PRODUKTŮ
   /* $('.products .product').each(function () {
        const $product = $(this);
        const productId = $product.find('span[data-micro="sku"]').text().trim();

        if (productId) {
            $product.find('.p-bottom').append(`
                <div class="customFavorite">
                    <span class="add-to-favorites" data-id="${productId}" data-ids='["${productId}"]'>
                        Přidat do oblíbených
                    </span>
                </div>
            `);
        }
    });*/
}

// Pomocné funkce
function isUserLoggedIn() {
    if (typeof getShoptetDataLayer !== 'function') return false;
    const customerData = getShoptetDataLayer('customer');
    return customerData && customerData.registered;
}

function getProjectId() {
    return getShoptetDataLayer('projectId');
}

function getFavoritesFromLocal(projectId) {
    let data = localStorage.getItem(`favorites-${projectId}`);
    return data ? JSON.parse(data) : [];
}

function saveFavoritesToLocal(projectId, data) {
    localStorage.setItem(`favorites-${projectId}`, JSON.stringify(data));
}

// Uložení nebo odebrání oblíbených
function toggleFavoritesBatch(productIds, productData, isRemoving, callback = null) {
    const projectId = getProjectId();

    if (isUserLoggedIn()) {
        const userId = getShoptetDataLayer('customer').guid;
        $.post('https://oblibene.shopcode.cz/favorite.php', {
            action: isRemoving ? 'remove' : 'add',
            user_id: userId,
            shop_id: projectId,
            product_ids: productIds,
            product_data: JSON.stringify(productData)
        }, function () {
            if (typeof callback === 'function') callback(!isRemoving);
        });
    } else {
        let favorites = getFavoritesFromLocal(projectId);
        if (isRemoving) {
            favorites = favorites.filter(f => !productIds.includes(f.product_id));
        } else {
            productIds.forEach(id => {
                if (!favorites.find(f => f.product_id === id)) {
                    favorites.push({ ...productData, product_id: id });
                }
            });
        }

        saveFavoritesToLocal(projectId, favorites);
        if (typeof callback === 'function') callback(!isRemoving);
    }
    loadFavoriteNumber();
}

// Zjištění stavu – je produkt v oblíbených?
function checkFavoritesStatus(callback) {
    const projectId = getProjectId();
    const isDetailPage = $('.p-info-wrapper').length > 0;

    let productIds = [];

    if (isDetailPage) {
        const productCodes = getShoptetDataLayer('product').codes || [];
        productIds = productCodes.map(codeObj => String(codeObj.code));
    } else {
        $('.products .product').each(function () {
            const productId = $(this).find('span[data-micro="sku"]').text().trim();
            if (productId) productIds.push(productId);
           // console.log(productId)
        });
    }

    if (!productIds.length) return;

    const applyStateToButtons = (favoriteIds) => {
        if (isDetailPage) {
            const $btn = $('.add-to-favorites');
            const isAnyFav = productIds.some(id => favoriteIds.includes(id));
            $btn.text(isAnyFav ? 'Odebrat z oblíbených' : 'Přidat do oblíbených');
            $btn.toggleClass('in-favorites', isAnyFav);
        } else {
            $('.products .product').each(function () {
                const $product = $(this);
                const productId = $product.find('a.image span[data-micro="sku"]').text().trim();
                const $btn = $product.find('.add-to-favorites');
              //  console.log(favoriteIds)
               // console.log(productId)
                const isFav = favoriteIds.includes(productId);

                $btn.text(isFav ? 'Odebrat z oblíbených' : 'Přidat do oblíbených');
                $btn.toggleClass('in-favorites', isFav);
            });
        }
    };

    if (isUserLoggedIn()) {
        const userId = getShoptetDataLayer('customer').guid;

        $.post('https://oblibene.shopcode.cz/favorite.php', {
            action: 'list',
            user_id: userId,
            shop_id: projectId,
            product_ids: productIds
        }, function (data) {
            const favoriteIds = Array.isArray(data) ? data.map(f => String(f.product_id)) : [];
       
            applyStateToButtons(favoriteIds);
            if (typeof callback === 'function') callback(favoriteIds);
        });
    } else {
        const localFavorites = getFavoritesFromLocal(projectId);
        const localIds = localFavorites.map(f => String(f.product_id));
        applyStateToButtons(localIds);
        if (typeof callback === 'function') callback(localIds);
    }
}

// Reakce na kliknutí na tlačítko
$(document).on('click', '.add-to-favorites', function () {
    const $btn = $(this);
    const productIds = JSON.parse($btn.attr('data-ids') || '[]');
    const isRemoving = $btn.hasClass('in-favorites');

    let $context;

    if ($('.p-info-wrapper').length) {
        $context = $('.p-info-wrapper');
        var productData = {
            name: $context.find('.p-detail-inner-header h1').first().text().trim(),
            image: $('.p-image-wrapper .p-image').find('img').first().attr('src'),
            price: $context.find('.price-final-holder').first().text().trim(),
            url: document.location.href
        };
    } else {
        $context = $btn.closest('.product');
    }

   

    toggleFavoritesBatch(productIds, productData, isRemoving, function (newStatus) {
        $btn.text(newStatus ? 'Odebrat z oblíbených' : 'Přidat do oblíbených');
        $btn.toggleClass('in-favorites', newStatus);
        loadFavoriteNumber();
    });

});


function loadFavoriteNumber(callback){
    const projectId = getProjectId();

    if (isUserLoggedIn()) {
        const userId = getShoptetDataLayer('customer').guid;

        $.post('https://oblibene.shopcode.cz/favorite.php', {
            action: 'list',
            user_id: userId,
            shop_id: projectId
        }, function (data) {
            const seenUrls = new Set();

            data.forEach(product => {
                try {
                    const parsedData = JSON.parse(product.product_data);
                    if (parsedData.url) {
                        seenUrls.add(parsedData.url);
                    }
                } catch (e) {
                    console.warn('Chyba při parsování product_data:', e);
                }
            });
            $('.favorite_icon').html(seenUrls.size)
        });
    } else {
        const favorites = getFavoritesFromLocal(projectId);
        const seenUrls = new Set();

        favorites.forEach(product => {
            if (product.url) {
                seenUrls.add(product.url);
            }
        });
        $('.favorite_icon').html(seenUrls.size)
    }
}

function renderFavorites(favorites) {
    const $container = $('<div class="favorites-list products-block"></div>');
    $('#content div[itemprop="about"]').append($container);

    const seenUrls = new Set();
    const uniqueFavorites = [];

    favorites.forEach(product => {
        if (!seenUrls.has(product.url)) {
            seenUrls.add(product.url);
            uniqueFavorites.push(product);
        }
    });

    if (!uniqueFavorites.length) {
        $container.html('<p>Nemáte žádné oblíbené produkty.</p>');
        return;
    }

    uniqueFavorites.forEach(product => {
        const $item = $(`
            <div class="product">
                <div class="p">
                    <a href="${product.url}" class="image">
                        <img src="${product.image}" alt="${product.name}">
                        <span class="p-code loaded">
                            Kód: <span data-micro="sku">${product.product_id}</span>
                        </span>
                    </a>
                    <div class="p-in">
                        <div class="p-in-in">
                            <a href="${product.url}" class="name" data-micro="url">
                                <span data-micro="name" data-testid="productCardName">${product.name}</span>
                            </a>
                        </div>
                        <div class="p-bottom single-button">
                            <div data-micro="offer">
                                <div class="p-tools">
                                    <a href="${product.url}" class="btn btn-primary">Detail</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `);

        $container.append($item);
    });
}



function loadFavorites(callback) {
    const projectId = getProjectId();

    if (isUserLoggedIn()) {
        const userId = getShoptetDataLayer('customer').guid;
        $.post('https://oblibene.shopcode.cz/favorite.php', {
            action: 'list',
            user_id: userId,
            shop_id: projectId
        }, function (data) {
            const $container = $('<div class="favorites-list products-block"></div>');
            $('#content div[itemprop="about"]').append($container);

            const seenUrls = new Set();
            const uniqueFavorites = [];

            data.forEach(product => {
                try {
                    const parsedData = JSON.parse(product.product_data);
                    product = { ...product, ...parsedData };
                } catch (e) {
                    console.error('Chyba při parsování product_data:', e);
                }
                if (!seenUrls.has(product.url)) {
                    seenUrls.add(product.url);
                    uniqueFavorites.push(product);
                }
            });

            if (!uniqueFavorites.length) {
                $container.html('<p>Nemáte žádné oblíbené produkty.</p>');
                return;
            }

            uniqueFavorites.forEach(product => {
           //     console.log(product)
                const $item = $(`
                    <div class="product">
                        <div class="p">
                            <a href="${product.url}" class="image">
                                <img src="${product.image}" alt="${product.name}">
                                <span class="p-code loaded">
                                    Kód: <span data-micro="sku">${product.product_id}</span>
                                </span>
                            </a>
                            <div class="p-in">
                                <div class="p-in-in">
                                    <a href="${product.url}" class="name" data-micro="url">
                                        <span data-micro="name" data-testid="productCardName">${product.name}</span>
                                    </a>
                                </div>
                                <div class="p-bottom single-button">
                                    <div data-micro="offer">
                                        <div class="p-tools">
                                            <a href="${product.url}" class="btn btn-primary">Detail</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                `);

                $container.append($item);
            });
        });
    } else {
        const localFavorites = getFavoritesFromLocal(projectId);
        renderFavorites(localFavorites);
    }
}

// Načíst stavy po načtení stránky
$(document).ready(function () {
    $('header#header .navigation-buttons, .responsive-tools').prepend('<a href="' + favorite_url + '" class="favorite"><i class="favorite_icon">0</i></a>');
    loadFavoriteNumber();
    checkFavoritesStatus();
   
    if (window.location.pathname === favorite_url) {
        $('main#content div.content-inner').attr('style', 'max-width:100%;width:100%;')
        loadFavorites();
        
    }
});


